import { Component, Input, Output, ViewChild, OnInit } from "@angular/core";
import { BaseComponent } from "../../../base.component";

import { RangeSelect, OptionButton } from "../../../_models/index";
import { Form, NgForm } from "@angular/forms";

import "rxjs/add/operator/catch";
import "rxjs/add/operator/debounceTime";
import "rxjs/add/operator/distinctUntilChanged";
import "rxjs/add/operator/do";
import "rxjs/add/operator/map";
import "rxjs/add/operator/switchMap";
import "rxjs/add/operator/merge";
// tslint:disable-next-line:no-duplicate-imports
import { Renderer2, ElementRef } from "@angular/core";
import { SessionManagerService } from "../../../_services/SessionManager/session-manager.service";
import { DataService } from "../../../_services/data.service";
import { AlertService } from "../../../_services/alert.service";

@Component({
  moduleId: module.id,
  selector: "rangeselect",
  templateUrl: "range-select.component.html",
  styleUrls: ["./range-select.component.scss"],
})
export class RangeSelectComponent extends BaseComponent {
  @Input() public rangeSelectData: RangeSelect;
  @Input() public optionButtons: OptionButton[];
  @Input() public form: NgForm;
  @ViewChild("dropdown") public dropdown: ElementRef;
  @ViewChild("dropdownButton") public dropdownButton: ElementRef;

  public dropdownIsOpen = false;
  public selectedOptionBtn: any;
  public fromInputValue: string;
  public toInputValue: string;

  constructor(
    public dataService: DataService,
    private alertService: AlertService,
    private renderer: Renderer2,
    public sessionManager: SessionManagerService
  ) {
    super(dataService, sessionManager);

    // close dropdown on click outside
    this.renderer.listen("window", "click", (e: Event) => {
      if (
        this.dropdownButton &&
        !this.dropdownButton.nativeElement.contains(e.target) &&
        this.dropdown &&
        !this.dropdown.nativeElement.contains(e.target)
      ) {
        this.dropdownIsOpen = false;
      }
    });
  }

  public run() {
    if (this.optionButtons && this.optionButtons.length > 0) {
      this.selectedOptionBtn = this.optionButtons[0].key;
    }
  }

  public toggleDropdown() {
    this.dropdownIsOpen = !this.dropdownIsOpen;
  }

  public clearFilter(ev) {
    ev.stopPropagation();
    // tslint:disable-next-line:prefer-conditional-expression
    if (this.optionButtons && this.optionButtons.length > 0) {
      this.selectedOptionBtn = this.optionButtons[0].key;
    } else {
      this.selectedOptionBtn = undefined;
    }
    this.fromInputValue = undefined;
    this.toInputValue = undefined;
  }

  public submit() {
    let r = {};
    r[this.rangeSelectData.formControlName] = {};
    r[this.rangeSelectData.formControlName]["from"] = this.fromInputValue;
    r[this.rangeSelectData.formControlName]["to"] = this.toInputValue;
    if (this.optionButtons && this.optionButtons.length > 0) {
      r[this.rangeSelectData.formControlName]["selectedOption"] =
        this.selectedOptionBtn;
    }
    return r;
  }
}



// WEBPACK FOOTER //
// ./src/app/admin/components/range-select/range-select.component.ts